import {
  DUE_DATE,
  VENDOR,
  DEPARTMENT,
  PARTICULARS,
  PROJECT,
  SUB_PROJECT,
  RELEASING_CENTER,
  SUPPORTING_DOCUMENTS,
  PROJECT_CLASSES,
  REQUEST_TYPE,
  GROSS_PRICE_PER_ITEM
} from 'types'

import {
  AUTOCOMPLETE_TYPE,
  DATETIME_PICKER_TYPE,
  FILE_INPUT_TYPE,
  INPUT_TYPE,
  SELECT_TYPE
} from '1.newComponents/fields/types'

// LABELS
export const LABELS = {
  [DUE_DATE]: 'Due date',
  [VENDOR]: 'Vendor',
  [DEPARTMENT]: 'Requesting Department',
  [PARTICULARS]: 'Particulars',
  [PROJECT]: 'Project',
  [SUB_PROJECT]: 'Sub Project',
  [RELEASING_CENTER]: 'Releasing Center',
  [GROSS_PRICE_PER_ITEM]: 'Amount',
  [SUPPORTING_DOCUMENTS]: 'Supporting documents'
}

// COMPONENT TO BE RENDERED
export const COMPONENTS = {
  [DUE_DATE]: DATETIME_PICKER_TYPE,
  [VENDOR]: AUTOCOMPLETE_TYPE,
  [DEPARTMENT]: SELECT_TYPE,
  [PARTICULARS]: INPUT_TYPE,
  [PROJECT]: AUTOCOMPLETE_TYPE,
  [SUB_PROJECT]: INPUT_TYPE,
  [RELEASING_CENTER]: SELECT_TYPE,
  [GROSS_PRICE_PER_ITEM]: INPUT_TYPE,
  [SUPPORTING_DOCUMENTS]: FILE_INPUT_TYPE
}

// SIZES OF INPUT FIELDS IN WIDTH
export const GRID = {
  [DUE_DATE]: { xs: 12, sm: 12, md: 6 },
  [VENDOR]: { xs: 12, sm: 12, md: 6 },
  [DEPARTMENT]: { xs: 12, sm: 12, md: 6 },
  [PARTICULARS]: { xs: 12, sm: 12, md: 6 },
  [PROJECT]: { xs: 12, sm: 12, md: 6 },
  [SUB_PROJECT]: { xs: 12, sm: 12, md: 6 },
  [RELEASING_CENTER]: { xs: 12, sm: 12, md: 6 },
  [GROSS_PRICE_PER_ITEM]: { xs: 12, sm: 12, md: 6 },
  [SUPPORTING_DOCUMENTS]: { xs: 12, sm: 12 }
}

// SIZES OF INPUT FIELDS IN PLACEHOLDERS
export const PLACEHOLDERS = {
  [VENDOR]: 'Required',
  [DEPARTMENT]: 'Required',
  [PARTICULARS]: 'Required',
  [PROJECT]: 'Required',
  [SUB_PROJECT]: 'Optional',
  [GROSS_PRICE_PER_ITEM]: '0.00'
}
